import { useUserContext } from "@/contexts/userContext";
import { useRouter } from "next/router";
import { useEffect } from "react";
import CandlestickLoader from "@/components/loader/CandleStickLoader";
import { LuLoader2 } from "react-icons/lu";

const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const { user, userLoading } = useUserContext();
  const router = useRouter();

  const publicRoutes = [
    "/", // Landing page / login
    "/login_v2",
    "/create-new-account",
    "/marketplace",
    "/profile",
    "/invite",
    "/demo",
    "/sso",
    "/change-password",
    "/welcome-tour", // Maybe welcome tour should be protected? SubscriptionGuard handles it.
    "/prediction-market",
    "/embed/earnings",
    "/embed/pairs",
    "/embed/strategy-lab",
    "/embed/trending-events",
  ];

  const isPublicRoute = publicRoutes.some((route) => {
    if (route === "/") return router.pathname === "/";
    return router.pathname.startsWith(route);
  });

  useEffect(() => {
    // If session check is complete and no user is found on a protected route
    if (!userLoading && !user && !isPublicRoute) {
      router.push("/");
    }
  }, [user, userLoading, isPublicRoute, router]);

  // Show premium loader while session is being verified for protected routes
  if (userLoading && !isPublicRoute) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center  z-[9999]">
        <div className="flex flex-col items-center gap-8">
          <div className="flex flex-col items-center gap-3 text-center">
            <LuLoader2></LuLoader2>
          </div>
        </div>
      </div>
    );
  }

  // If not loading or on public route, show children
  // Even if user is null on public route, we show children
  return <>{children}</>;
};

export default AuthGuard;
